import React,{useEffect,useState} from 'react'
import DashboardLayout from '../../layoutcontainers/DashboardLayout'
import MaterialDataGrid from '../../components/MaterialDataGrid'
import MaterialTypography from '../../components/MaterialTypography'
import { Card, CardHeader, Stack } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import MaterialButton from '../../components/MaterialButton'
import AddIcon from '@mui/icons-material/Add';
import MaterialBox from '../../components/MaterialBox'
import MaterialSelect from '../../components/MasterSelect'
import axios from 'axios'
import BASEURL from '../Utils/Baseurl'
import TableComponent from '../../components/GridTable/TableComponent'
function TaskCreationList() {

    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState(false);
    const [pageState, setPageState] = useState({
            loading: false,
            error: false,
            message: "",
            state: 'init'
    })
    
    const [employeeList, setEmployeeList] = useState([])
    const Statusdata = [
        {value:"Waiting",label:'Waiting'},
        {value:"In Progress",label:'In Progress'},
        {value:"Follow-Up",label:'Follow-Up'},
        {value:"Completed",label:'Completed'},
        {value:"Overdue",label:'Overdue'},
    ]

    const employeeListTable = {
        columns: [
            { field: "tasktitle", label: "Task Title", flex: 1, disableColumnMenu: true, editable: false },
            { field: "module", label: "Module", flex: 1, editable: false, disableColumnMenu: true },
            { field: "assignsalesperson", label: "Assign Salesperson", flex: 1, disableColumnMenu: true, editable: false },
            { field: "customername", label: "Customer Name", flex: 1, disableColumnMenu: true, editable: false },
            { field: "leadname", label: "Lead Name", flex: 1, disableColumnMenu: true, editable: false },
            { field: "startdate", label: "Start Date", flex: 1, disableColumnMenu: true, editable: false },
            { field: "enddate", label: "End Date", flex: 1, disableColumnMenu: true, editable: false },
        ],
         rows : employeeList.map((item)=>({
            id : item.id,
            tasktitle : item.title,
            module : item.module,
            assignsalesperson : item.assignedTo?.username,
            customername : item?.customer?.legalName,
            leadname : item?.lead?.companyName,
            startdate : item?.startDate.slice(0,10),
            enddate : item?.endDate.slice(0,10)
         }))
      };
        
       
        
    useEffect(() => {
        getEmployeeList()
    }, [])

    const getEmployeeList = async () => {

          const query = 
          `query { 
            allTasks { 
              success 
              message 
              data { 
                id 
                title 
                description 
                module 
                priority 
                status 
                requestedDate 
                startDate 
                endDate 
                deadlineDate 
                customer { 
                  id 
                  legalName 
                } 
                lead { 
                  id 
                  firstName 
                  companyName
                } 
                assignedTo { 
                  id 
                  username 
                } 
              } 
            } 
          } `;
          setIsLoading(true);
            try {
              const response = await axios.post(
                BASEURL,
                {
                  query: query,
                },
                {
                  headers: {
                    "Content-Type": "application/json",
                  },
                }
              );
              let result = response.data.data?.allTasks?.data
              setEmployeeList(result)
            } catch (error) {
              console.error('ExpenseError:',error);
              
            }
            finally{
              setIsLoading(false);
            }
            // setEmployeeList(res.data.employeeList)
        }
    
        const handleNewEmployee = () => {
            navigate('/taskcreation/addtaskcreation')
        }
    
        const onEmployeeListClick = (e) => {
            if (e?.id) {
                navigate(`/taskcreation/addtaskcreation?id=${e?.id}`)
            }
        }

  const onCheck=(list)=>
    {
      console.log("id-c",list)
    }

  const onDeleteALL=()=>
      {
        console.log("id-DELE")
      }

  const onDelete=(id)=>
        {
          console.log("id-d",id)
        }

  return (
    <DashboardLayout>
      <TableComponent
      tableLoading={isLoading ? true : false }
      columns={employeeListTable.columns}
      rowsData={employeeListTable.rows}
      styles={{ paper: { padding: '16px' } }}
      head="Task List"
      actions={true}
      checked={false}
      view={true}
      showAdd = {true}
      onCheck={onCheck}
      onEdit={onEmployeeListClick}
      onDelete={onDelete}
      onView={onEmployeeListClick}
      onDeleteALL={onDeleteALL}
      addList={() => handleNewEmployee()}
      />
    {/* <Card>
    <CardHeader
          title={
            <>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
                margin={1}
              >
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                 Task Creation list
                  </MaterialTypography>
                </Stack>
               
                    <Stack alignItems="" lineHeight={1}>
                      <MaterialButton
                        variant="gradient"
                        color="dark"
                        size="small"
                        startIcon={<AddIcon />}
                        onClick={handleNewEmployee}
                      >
                        Add Task 
                      </MaterialButton>
                    </Stack>
                 
              </Stack>

              <Stack
                direction="row"
                //   justifyContent="space-between"
                //   alignItems="center"
                marginTop={0}
                spacing={0}
              >
              

                <Stack marginLeft={2}>
                  <MaterialBox lineHeight={1} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                      lineHeight={3}
                      color="black"
                    >
                      Status
                    </MaterialTypography>
                  </MaterialBox>

                  <MaterialSelect
                    name="status"
                    options = {Statusdata}
                    error={false}
                    // success={true}
                    // isClearable
                  />
                </Stack>
              </Stack>
            </>
          }
        />


        <MaterialDataGrid
            // customHeight={550}
            rows={employeeListTable.rows}
            columns={employeeListTable.columns}
            checkboxSelection={false}
            isSelectable={false}
            onRowClick={onEmployeeListClick}
            loading={pageState.loading}
            localeText={{
                noRowsLabel: (
                    <Stack direction="column" alignItems="center" justifyContent="center" spacing={1}>
                        <MaterialTypography variant="body2" fontWeight="medium" color="text">
                            No employee found
                        </MaterialTypography>
                        <MaterialTypography variant="caption" color="text">
                            You have not yet add any employee details. Click on the "Add Employee" button to start adding employee details.
                        </MaterialTypography>
                    </Stack>
                )
            }}
        />
    </Card> */}
</DashboardLayout>
  )
}

export default TaskCreationList
